import { Translate } from 'react-redux-i18n'
import { positionDropdown } from '../../../../common/dropdown'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Tooltip } from '../../../../common/tooltip'
import classes from './index.module.scss'

export const DefaultInfo = () => {
  return (
    <Element className={classes.defaultInfo} style={{ borderColor: '#D5D5D5' }}>
      <Element elementName="span" className="fw600">
        <Translate value="screening.DEFAULT_INFO" />
      </Element>
      <Tooltip
        tooltipContent="screening.DEFAULT_INFO_TOOLTIP"
        isI18n
        position={positionDropdown.TOP_END_LEFT}
      >
        <Icon
          className="icon-info-circle"
          style={{ color: '#9C9C9C', fontSize: 16 }}
        />
      </Tooltip>
    </Element>
  )
}
